import { useState } from "react";
import type { AgentModelDto } from "../../types/index.ts";

const KEY = "sc-model";

/**
 * The model the person last chose, kept in this browser — a preference, not a record. Falls back
 * to the server's default (the first) when nothing is kept, or what is kept is no longer offered.
 */
export function useModelChoice(models: AgentModelDto[]): [string | null, (id: string) => void] {
  const [chosen, setChosen] = useState<string | null>(() => {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return null;
    }
  });
  const model = models.some((m) => m.id === chosen) ? chosen : (models[0]?.id ?? null);
  const choose = (id: string) => {
    setChosen(id);
    try {
      localStorage.setItem(KEY, id);
    } catch {
      // Private window or blocked storage: the choice holds until the page is closed.
    }
  };
  return [model, choose];
}
